import { render, staticRenderFns } from "./ChainProduct.vue?vue&type=template&id=43696cd7&scoped=true"
import script from "./ChainProduct.vue?vue&type=script&lang=js"
export * from "./ChainProduct.vue?vue&type=script&lang=js"
import style0 from "./ChainProduct.vue?vue&type=style&index=0&id=43696cd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43696cd7",
  null
  
)

export default component.exports